"use client";

import { useSidebar } from "@/contexts/SidebarContext";
import { Menu } from "lucide-react";
import { usePathname } from "next/navigation";

export default function MobileHeader() {
    const { setIsMobileOpen } = useSidebar();
    const pathname = usePathname();

    // Don't show on auth pages or public pages
    const isPublic = [
        "/auth/login",
        "/auth/register",
        "/auth/forgot-password",
        "/",
        "/public/verify-email"
    ].includes(pathname || "") || pathname?.startsWith("/public");

    if (isPublic) return null;

    return (
        <header className="fixed top-0 left-0 right-0 z-40 md:hidden bg-slate-900/95 backdrop-blur-sm border-b border-slate-800">
            <div className="flex items-center justify-between h-14 px-4">
                {/* Menu Button */}
                <button
                    onClick={() => setIsMobileOpen(true)}
                    className="p-2 -ml-2 rounded-lg hover:bg-slate-800 text-slate-400 hover:text-white transition-colors"
                    aria-label="Open menu"
                >
                    <Menu size={24} />
                </button>

                {/* Logo */}
                <div className="font-bold text-lg tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-cyan-400">
                    Vibe Coder
                </div>

                {/* Spacer for centering */}
                <div className="w-10" />
            </div>
        </header>
    );
}
